import * as React from "react"

function SvgSingleNeutralCircle(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.667}
      >
        <path d="M20 .833C30.585.833 39.167 9.415 39.167 20S30.585 39.167 20 39.167.833 30.585.833 20 9.415.833 20 .833z" />
        <path d="M20 7.5a7.084 7.084 0 110 14.168A7.084 7.084 0 0120 7.5zm10.528 23.333c-2.75-5.815-9.693-8.298-15.508-5.548a11.648 11.648 0 00-5.548 5.548" />
      </g>
    </svg>
  )
}

export default SvgSingleNeutralCircle
